import { type ReactElement } from "react";

import type { Photo, StudyProtocolConfig } from "../../api/types";
import { pickInstruction, webcamCountPhrase } from "../../features/dashboard/protocol";
import { TabPanel } from "../Tabs";
import { DailyFlow } from "./DailyFlow";
import { PhotoLibrary } from "./PhotoLibrary";

// Photos tab: capture + browse. Today's submission (DailyFlow — webcam
// multi-capture and/or file upload + optional daily factors, driven by the
// study's protocol config) with the date-folder photo library beneath it
// (hot window only — photos past FACEAGE_ARCHIVE_HOT_DAYS are archived and
// leave this view). The library moved back here 2026-08-07 when Trends became
// analytics-only; the Daily Log shows the same photos per diary day.
export function PhotosTab({
  onProcessed,
  config,
  studyDay,
  photos,
}: {
  onProcessed: () => Promise<void>;
  config: StudyProtocolConfig;
  studyDay: number | null;
  photos: Photo[];
}): ReactElement {
  const webcamOnly = !config.photo.methods.includes("file");
  const instruction = pickInstruction(config.instructions, studyDay);
  return (
    <TabPanel
      id="photos"
      title={instruction?.title ?? (webcamOnly ? "Daily webcam capture" : "Upload photos")}
    >
      <p className="muted pre-wrap">
        {instruction?.markdown ??
          (webcamOnly
            ? `Capture ${webcamCountPhrase(config.photo)} webcam photos each day.${config.results_visible ? "" : " Your results are recorded for the study."}`
            : "Add today's photos with your webcam or by uploading files. You can submit on as many days as you like.")}
      </p>
      <DailyFlow active onProcessed={onProcessed} config={config} />
      <PhotoLibrary photos={photos} resultsVisible={config.results_visible} />
    </TabPanel>
  );
}
